import { gql, useMutation } from '@apollo/client'

const mutation = gql`
   mutation requestNoteLock($id: ID!) {
      requestNoteLock(id: $id) {
         id
         locked
         lockedByCurrentConnection
      }
   }
`

const useRequestNoteLock = (mutationHookOptions) => {
   const [requestNoteLock, { called, client, data, error, loading }] =
      useMutation(mutation, mutationHookOptions)

   const wrappedMutationFn = (filter, input, mutationFnOptions) => requestNoteLock({
      variables: { ...filter, input },
      ...mutationFnOptions
   })

   return {
      requestNoteLock: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useRequestNoteLock
